import React, { useEffect, useState } from 'react';
import { Page, Text, View, Document, StyleSheet, pdf } from '@react-pdf/renderer';
// import { saveAs } from 'file-saver';
import { locales } from '../../../translations/locales';
import { _$ } from '../../../controllers/dom';
import moment from 'moment';

// Définir des styles
const styles = StyleSheet.create({
    page: {
        padding: 20,
        fontSize: 12,
        fontFamily: 'Times-Roman',
    },
    section: {
        marginBottom: 10,
        marginTop: 10,
    },
    header: {
        fontSize: 12,
        marginBottom: 10,
    },
    bold: {
        fontFamily: 'Times-Bold',
    },
    line: {
        marginVertical: 5,
        width: '100%',
        height: 1,
        backgroundColor: 'black',
        marginBottom: '10px',
        marginTop: '10px',
    },
    text: {
        marginBottom: 5,
    },
    content: {
        marginLeft: 40,
    },
    moyensContainer: {
        marginTop: 10,
    },
    moyensLine: {
        display: 'flex',
        flexDirection: 'row',
        marginLeft: 60,
        marginBottom: 5,
    },
});

// Créer un composant pour le PDF
const MyDocument = (props) => {
    const { alert, locale } = props;

    return (
        <Document>
            <Page style={styles.page}>
                <Text style={styles.text}>
                    {moment(Date.now()).format('Do MMMM YYYY HH:mm:ss')} {locales[locale].ticket.title} {alert.buildingName}
                </Text>
                <View style={styles.line} />

                <Text style={styles.header}>
                    DATE: <Text style={styles.bold}>{moment(alert.time).format('Do MMMM YYYY HH:mm:ss')}</Text> -
                    INTERVENTION: <Text style={styles.bold}>{alert.number}</Text>
                </Text>

                <View style={styles.section}>
                    <Text>NATURE:
                        <Text style={styles.bold}>{locales[locale].sga[alert.qualification.category]} {alert.qualification.qualification}</Text>
                    </Text>
                    <Text style={[styles.content, styles.bold]}>
                        {locales[locale].sig[alert.qualification.place?.category]} {locales[locale].sig[alert.qualification.place?.type]}
                    </Text>
                </View>

                <View style={styles.section}>
                    <Text>INFORMATIONS:</Text>
                    <Text style={[styles.content, styles.bold]}>{alert.qualification.informations}</Text>
                </View>
                <View style={styles.line} />

                <View style={styles.section}>
                    <Text>{locales[locale].ticket.adress}:</Text>
                    <Text style={[styles.content, styles.bold]}>{`${alert.location.numero} ${alert.location.address} ${alert.location.city}`}</Text>
                    <Text style={styles.content}>
                        {locales[locale].sga.stage} {alert.location.stage} / {locales[locale].sga.gate} {alert.location.gate} /
                        {locales[locale].sga.building} {alert.location.building} / {locales[locale].sga.code} {alert.location.code}
                    </Text>
                    <Text style={styles.content}>
                        {locales[locale].sga.observations} {alert.location.observations}
                    </Text>
                </View>
                <View style={styles.line} />

                <View style={styles.section}>
                    <Text>{locales[locale].ticket.vehicle}:</Text>
                    <View style={styles.moyensContainer}>
                        <View style={styles.section}>
                            <Text style={[styles.content, styles.bold]}>{alert.vehicle.name} [{alert.vehicle.armedFunction}]</Text>
                            {alert.vehicle.manning.map((manning, y) => (
                                <View key={y} style={styles.moyensLine}>
                                    <Text>{manning.skill.split('_#2')[0]}</Text>
                                    <Text>:</Text>
                                    <Text>
                                        {manning.player?.name}
                                    </Text>
                                </View>
                            ))}
                        </View>
                    </View>
                </View>
                <View style={styles.line} />

                <View style={styles.section}>
                    <Text>{locales[locale].ticket.vehicles}:</Text>
                    {alert.vehicles.map((moyen, i) => (
                        <Text key={i} style={[styles.content, styles.bold]}>
                            {moment(moyen.time).format('HH:mm')}: {moyen.buildingName} {moyen.name} [{moyen.armedFunction}]
                        </Text>
                    ))}
                </View>
            </Page>
        </Document>
    );
};

// Télécharger le PDF
const Ticket = (props) => {
    const { ModuleRP, locale, missionId, vehicleId, buildingId } = props;
    const [alert, setAlert] = useState(null);
    const [impTicket, setImpTicket] = useState(false);

    const generatePDF = async (alertData) => {
        const blob = await pdf(<MyDocument alert={alertData} locale={locale} />).toBlob();
        // saveAs(blob, `nexsimu-rp-start-${alert.number}.pdf`);
        const url = URL.createObjectURL(blob);
        window.open(url);
        setImpTicket(true);
        _$('btn-ticket').remove();
    };

    const getAlert = () => {
        ModuleRP.impTicket(missionId, vehicleId, buildingId, setAlert);
    };

    useEffect(() => {
        if (alert && !impTicket) {
            generatePDF(alert);
        }
    }, [alert]);

    return (
        <button
            type='button'
            className='btn btn-info'
            id='btn-ticket'
            onClick={getAlert}
        >
            {locales[locale].assignments.departureTicket}
        </button>
    );
};

export default Ticket;
